import {
  text,
  boolean,
  number,
  object,
  select,
  array,
} from '@storybook/addon-knobs';
import { action } from '@storybook/addon-actions';
import { storiesOf } from '@storybook/react';
import * as React from 'react';
import { TInvestmentReturn } from '@assetmark/common-elements/';
import { InvestmentReturnComponent } from './investmentReturn';
import { TAssessRiskProfile } from '../models/assessRiskProfile.model';

let height = 50;
let investmentAmount = 10000;
let investmentRangeData: TAssessRiskProfile[] = [];

investmentRangeData.push({
  gainLoss: {
    gainPercent: 43,
    longTermAveragePercent: 20,
    lossPercent: 20,
  },
  id: 0,
});

investmentRangeData.push({
  gainLoss: {
    gainPercent: 52,
    longTermAveragePercent: 20,
    lossPercent: 25,
  },
  id: 1,
});

investmentRangeData.push({
  gainLoss: {
    gainPercent: 56,
    longTermAveragePercent: 20,
    lossPercent: 30,
  },
  id: 2,
});

investmentRangeData.push({
  gainLoss: {
    gainPercent: 62,
    longTermAveragePercent: 20,
    lossPercent: 35,
  },
  id: 3,
});

investmentRangeData.push({
  gainLoss: {
    gainPercent: 72,
    longTermAveragePercent: 20,
    lossPercent: 37,
  },
  id: 4,
});

investmentRangeData.push({
  gainLoss: {
    gainPercent: 82,
    longTermAveragePercent: 20,
    lossPercent: 39,
  },
  id: 4,
});

let choices = [
  {
    choiceId: 1,
    sequence: 1,
    choice: 'Low',
    score: 0.33333298563957214,
    selected: true,
  },
  {
    choiceId: 2,
    sequence: 2,
    choice: 'Moderate',
    score: 0.6666659712791443,
    selected: false,
  },
  {
    choiceId: 3,
    sequence: 3,
    choice: 'High',
    score: 0.9999989867210388,
    selected: false,
  },
  {
    choiceId: 4,
    sequence: 4,
    choice: 'Very High',
    score: 1.3333319425582886,
    selected: false,
  },
  {
    choiceId: 5,
    sequence: 5,
    choice: 'Very High',
    score: 1.3333319425582886,
    selected: false,
  },
  {
    choiceId: 6,
    sequence: 6,
    choice: 'Very High',
    score: 1.3333319425582886,
    selected: false,
  },
];

export const actions = {
  onBackButtonClick: action('onBackButtonClick'),
  onNextButtonClick: action('onNextButtonClick'),
  onSkipButtonClick: action('onSkipButtonClick'),
};

storiesOf('Investment Return', module).add('default', () => {
  return (
    <div style={{ width: '930px' }}>
      <InvestmentReturnComponent
        barRangeSelected={2}
        choices={choices}
        invesetmentRangeData={investmentRangeData}
        investmentAmount={number('Investment Amount', 50000)}
        {...actions}
      />
    </div>
  );
});
